import { DialogProps } from '@radix-ui/react-dialog';
import cn from 'classnames';
import { ComponentPropsWithoutRef, ReactNode } from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import styles from './sheet.module.scss';


export const SheetClose = DialogPrimitive.Close;

type RootProps = {
    className?: string;
    children?: ReactNode;
} & DialogProps

type ContentProps = ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & {
    children: ReactNode;
}

type TriggerProps = {
    className?: string;
    children?: ReactNode;
    asChild?: boolean;
}

export function Sheet ({ children, className, ...props }: RootProps) {
    return (
        <div className={ className }>
            <DialogPrimitive.Root { ...props }>
                { children }
            </DialogPrimitive.Root>
        </div>
    );
}

export function SheetTrigger ({ children, className, asChild }: TriggerProps) {
    return (
        <div className={ className }>
            <DialogPrimitive.Trigger asChild={ asChild }>
                { children }
            </DialogPrimitive.Trigger>
        </div>
    );
}

export function SheetContent ({ className, children, ...props }: ContentProps) {
    return (
        <DialogPrimitive.Portal>
            <DialogPrimitive.Content
                className={ cn(styles.content, className) }
                { ...props }
            >
                { children }
            </DialogPrimitive.Content>
        </DialogPrimitive.Portal>
    );
}
